import React, { useState } from 'react';
import axios from 'axios';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPaperPlane,
  faUserAlt,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { Box, Center, VStack, Wrap, WrapItem } from '@chakra-ui/layout';
import { FormControl, FormLabel } from '@chakra-ui/form-control';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/input';
import { Textarea } from '@chakra-ui/textarea';

export default function Contact() {
  const submit = <FontAwesomeIcon icon={faPaperPlane} />;
  const user = <FontAwesomeIcon icon={faUserAlt} />;
  const email = <FontAwesomeIcon icon={faEnvelope} />;
  const [fieldErrors, setFieldErrors] = useState({});
  const validationRules = {
    email: (val) => val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
    message: (val) => !!val,
    name: (val) => !!val,
    companyName: (val) => !!val,
  };
  // Input Change Handling
  const [inputs, setInputs] = useState({
    name: '',
    email: '',
    message: '',
  });

  const validate = () => {
    let errors = {};
    let hasErrors = false;
    for (let key of Object.keys(inputs)) {
      errors[key] = !validationRules[key](inputs[key]);
      hasErrors |= errors[key];
    }
    setFieldErrors((prev) => ({ ...prev, ...errors }));
    return !hasErrors;
  };
  const renderFieldError = (field) => {
    if (fieldErrors[field]) {
      return <p className="errorMessage">Please enter a valid {field}.</p>;
    }
  };

  const handleOnChange = (e) => {
    e.persist();
    setInputs((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  // Server State Handling
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });
  const handleServerResponse = (ok, msg) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      setFieldErrors({});
      setInputs({
        name: '',
        email: '',
        message: '',
      });
    }
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    setServerState({ submitting: true });
    axios
      .post(`https://formspree.io/${process.env.REACT_APP_API_URL}`, {
        data: inputs,
      })
      .then((result) => {
        handleServerResponse(
          true,
          'Thank you! Your message has been successfully sent. I will contact you very soon! Have a great day!',
        );
      })
      .catch((err) => {
        handleServerResponse(false, err.response.data.error);
      });
  };
  return (
    <div className="row">
      <fieldset>
        <legend className="row row-1">Get in touch</legend>

        <div className="row row-2">
          <p>
            I am happy to talk with you, whether about a project collaboration
            or just to say hi, simply fill out the form below or send an email
            to <span>irinagastmaier@gmail.com</span>.
          </p>
        </div>
        <div className="row row-3">
          <form onSubmit={handleOnSubmit} noValidate>
            <Center>
              <Wrap>
                <WrapItem>
                  <Box bg="gray.200" borderRadius="lg">
                    <Box m={8} color="#0B0E3F">
                      <VStack spacing={5}>
                        <FormControl id="name">
                          <FormLabel>Your Name</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={user}
                            />

                            <Input
                              id="name"
                              type="text"
                              size="md"
                              required
                              onChange={handleOnChange}
                              value={inputs.name}
                              className={fieldErrors.name ? 'error' : ''}
                              focusBorderColor="rgba(39, 72, 77,0.5)"
                            />
                            {renderFieldError('name')}
                          </InputGroup>
                        </FormControl>
                        <FormControl id="mail">
                          <FormLabel>Mail</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={email}
                            />
                            <Input
                              type="text"
                              size="md"
                              required
                              onChange={handleOnChange}
                              id="email"
                              value={inputs.email}
                              className={fieldErrors.email ? 'error' : ''}
                              focusBorderColor="rgba(39, 72, 77,0.5)"
                            />
                            {renderFieldError('email')}
                          </InputGroup>
                        </FormControl>
                        <FormControl id="message">
                          <FormLabel>Message</FormLabel>
                          <Textarea
                            borderColor="gray.300"
                            _hover={{
                              borderRadius: 'gray.300',
                            }}
                            id="message"
                            placeholder="message"
                            onChange={handleOnChange}
                            value={inputs.message}
                            className={fieldErrors.message ? 'error' : ''}
                            focusBorderColor="rgba(39, 72, 77,0.5)"
                          />
                          {renderFieldError('message')}
                        </FormControl>
                        <FormControl id="button" float="right">
                          <button
                            className="btn"
                            type="submit"
                            title="Submit"
                            disabled={serverState.submitting}
                          >
                            {submit}
                          </button>
                          {serverState.status && (
                            <p
                              className={
                                !serverState.status.ok ? 'errorMsg' : ''
                              }
                            >
                              {serverState.status.msg}
                            </p>
                          )}
                        </FormControl>
                      </VStack>
                    </Box>
                  </Box>
                </WrapItem>
              </Wrap>
            </Center>
          </form>
        </div>
      </fieldset>
      <Footer />
    </div>
  );
}
